module.exports = {

    props: {
        user: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            data: null,
            projects: [],
            technician: this.user,
        }
    },

    mounted() {
        this.fetchTestingHistory();
    },

    methods: {

        fetchTestingHistory() {
            App.request().get(`/testing-history/${this.technician.slug}`).then(response => {
                this.data = response.data
                this.projects = _.reverse(response.data.projects)
                this.$nextTick(() => {
                    $('[data-toggle="tooltip"]').tooltip()
                    $('[data-toggle="popover"]').popover({
                        placement: 'top',
                        trigger: 'hover',
                        html: true,
                    });
                })
            })
        },

        haveDaylightTest(project) {
            return !!_.filter(project.groups, group => group.code == 'NRCA-LTI-03-A').length
        }
    },

    computed: {
        historyEvents() {
            var projects = _.map(this.projects, project => {
                return {
                    date: project.completed_at,
                    is_project: true,
                    name: 'Project Completed',
                    data: project
                }
            })
            var audits = _.map(this.data.audits, audit => {
                return {
                    date: audit.notified_at,
                    is_project: false,
                    name: 'Field Audit',
                    data: audit
                }
            })
            var inspections = _.map(this.data.inspections, inspection => {
                return {
                    date: inspection.notified_at,
                    is_project: false,
                    name: 'Field Inspection',
                    data: inspection
                }
            })
            return _.orderBy(audits.concat(projects).concat(inspections), event => {
                return event.date;
            })
        }
    }

}
